import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
export interface ApplicationPayload {
  coverLetter: string;
  cvPath?: string;
  answers: { questionId: string; question: string; answer: string }[];
}

export interface MyCv {
  id: string;
  imagePath: string;
  pdfPath: string;
  wordPath: string;
}

@Injectable({ providedIn: 'root' })
export class ApplyService {

  private apiUrl = `${environment.apiUrl}api/job-posts`;

  constructor(private http: HttpClient) {}

  applyWithCvFile(
    jobPostId: string,
    payload: ApplicationPayload,
    cvFile: File
  ): Observable<any> {
    const formData = new FormData();
    // Create a Blob with explicit application/json type so Spring can deserialize it
    const jsonBlob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
    formData.append('data', jsonBlob);
    formData.append('cv', cvFile);
    
    console.log('Uploading CV file:', {
      jobPostId,
      fileName: cvFile.name,
      fileSize: cvFile.size,
      fileType: cvFile.type,
      payload
    });
    
    return this.http.post(`${this.apiUrl}/${jobPostId}/applications`, formData);
  }

  applyWithCvPath(
    jobPostId: string,
    payload: ApplicationPayload
  ): Observable<any> {
    const formData = new FormData();
    const jsonBlob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
    formData.append('data', jsonBlob);
    
    console.log('Applying with CV path:', {
      jobPostId,
      payload
    });
    
    return this.http.post(`${this.apiUrl}/${jobPostId}/applications`, formData);
  }

  getMyCvs(): Observable<MyCv[]> {
    return this.http.get<MyCv[]>(`${environment.apiUrl}api/my-cvs`);
  }
}